module.exports = __webpack_public_path__ + "img/2017_innovation2.1dab4e81.jpg";